/**
 * Slovníky výlohy (Fáze 2 – jazyky). Základ cs + sk; de/pl se doplní stejným
 * způsobem. Klíče jsou stabilní; text se dá měnit bez zásahu do komponent.
 *
 * Zatím pokrývá viditelné chrome (lišta, navigace, patička, košík). Hlubší
 * texty (detail produktu, pokladna) se přidávají po klíčích postupně.
 */
export const LANGS = ['cs', 'sk', 'de', 'pl'] as const;
export type Lang = (typeof LANGS)[number];

export const LANG_LABELS: Record<Lang, string> = {
  cs: 'Čeština',
  sk: 'Slovenčina',
  de: 'Deutsch',
  pl: 'Polski',
};
export const LANG_SHORT: Record<Lang, string> = { cs: 'CZ', sk: 'SK', de: 'DE', pl: 'PL' };

type Dict = Record<string, string>;

const cs: Dict = {
  'bar.sameDay': 'Odesíláme týž den',
  'bar.freeShip': 'Doprava zdarma od {amount}',
  'bar.returns': 'Vrácení do 30 dnů',
  'nav.myOrder': 'Moje objednávka',
  'nav.account': 'Účet a košík',
  'cart.title': 'Košík',
  'cart.goodsTotal': 'Zboží celkem',
  'cart.toCart': 'Do košíku',
  'cart.checkout': 'K pokladně',
  'cart.shippingNote': 'Doprava se dopočítá v pokladně.',
  'cart.empty': 'Obsah košíku',
  'freeship.remaining': 'Do dopravy zdarma zbývá',
  'freeship.reached': 'Máš dopravu zdarma 🎉',
  'footer.tagline': 'Chovatelské potřeby pro ty, kdo doma nejsou sami.',
  'poll.title': 'Anketa',
  'poll.vote': 'Hlasovat',
  'poll.thanks': 'Děkujeme za váš hlas.',
  'poll.totalVotes': 'Celkem hlasů: {count}',
  'skip.toContent': 'Přeskočit na obsah',
  'lang.switch': 'Jazyk',
  'cart.emptyMsg': 'Košík je prázdný.',
  'cart.backToShop': 'Zpátky do obchodu',
  'cart.priceChanged': 'Ceny se od vložení do košíku změnily. Platí částka uvedená níž.',
  'cart.colGoods': 'Zboží',
  'cart.colQty': 'Počet',
  'cart.colTotal': 'Celkem',
  'cart.remove': 'Odebrat',
  'cart.settlement': 'Ceny jsou orientačně přepočtené kurzem ČNB. Účtujeme v korunách: {amount}.',
  'cart.freeShip': 'Doprava zdarma.',
  'cart.shipFrom': 'Doprava od {price} — konkrétní možnosti vybereš v dalším kroku.',
  'cart.continueShopping': 'Pokračovat v nákupu',
  'co.title': 'Pokladna',
  'co.submitError': 'Objednávku se nepodařilo odeslat.',
  'co.contact': 'Kontakt',
  'co.email': 'E-mail',
  'co.phone': 'Telefon',
  'co.shippingAddress': 'Doručovací adresa',
  'co.fullName': 'Jméno a příjmení',
  'co.street': 'Ulice a číslo popisné',
  'co.city': 'Město',
  'co.zip': 'PSČ',
  'co.country': 'Země doručení',
  'co.countryCZ': 'Česko',
  'co.countrySK': 'Slovensko',
  'co.countryDE': 'Německo',
  'co.countryPL': 'Polsko',
  'co.countryAT': 'Rakousko',
  'co.ossNote': 'Objednávka do zahraničí: účtuje se DPH cílové země (režim OSS). Cena vč. DPH zůstává stejná, mění se jen rozpad daně.',
  'co.shipping': 'Doprava',
  'co.loading': 'Načítám…',
  'co.freeOver': 'Zdarma při nákupu nad {amount}',
  'co.free': 'zdarma',
  'co.pickPoint': 'Vyber výdejní místo',
  'co.payment': 'Platba',
  'co.note': 'Poznámka',
  'co.noteHint': 'Cokoli, co bychom měli vědět (nepovinné)',
  'co.summary': 'Souhrn',
  'co.goods': 'Zboží',
  'co.discount': 'Sleva {code}',
  'co.total': 'Celkem',
  'co.settlement': 'Ceny jsou orientačně přepočtené kurzem ČNB. Platba probíhá v korunách — účtujeme {amount}.',
  'co.couponLabel': 'Slevový kód',
  'co.couponApply': 'Použít',
  'co.couponApplied': 'Kód {code} uplatněn.',
  'co.voucher': 'Dárkový poukaz',
  'co.voucherApply': 'Použít',
  'co.voucherApplied': 'Poukaz {code} uplatněn.',
  'co.errVoucher': 'Poukaz se nepodařilo ověřit.',
  'co.errVoucherChanged':
    'Z dárkového poukazu by se strhlo víc, než ukazoval souhrn (například skončila akce). Zkontroluj prosím souhrn a objednávku odešli znovu.',
  'co.terms': 'Souhlasím s obchodními podmínkami a zpracováním osobních údajů.',
  'co.submitting': 'Odesílám…',
  'co.submit': 'Závazně objednat',
  'co.errShipping': 'Nepodařilo se načíst dopravu.',
  'co.errCoupon': 'Kód se nepodařilo ověřit.',
  'co.promoDiscount': 'Akce',
  'promo.title': 'Uplatněné akce',
  'promo.saved': 'Ušetříte {amount}',
  'promo.gift': 'Dárek',
  'promo.giftFree': 'zdarma',
  'promo.freeUnits': 'Zdarma',
  'promo.setPrice': 'Zvýhodněná sada',
  'promo.almost': 'Do akce zbývá {amount}',
  'consent.title': 'Cookies a soukromí',
  'consent.text': 'Nezbytné cookies drží košík a přihlášení. Se souhlasem navíc anonymně měříme, jak se obchod používá, ať ho umíme zlepšovat.',
  'consent.acceptAll': 'Přijmout vše',
  'consent.essentialOnly': 'Jen nezbytné',
  'consent.settings': 'Nastavení',
  'consent.save': 'Uložit volbu',
  'consent.close': 'Zavřít',
  'consent.essentialLabel': 'Nezbytné',
  'consent.essentialDesc': 'Košík, přihlášení, jazyk a měna. Bez nich obchod nefunguje – nejdou vypnout. Patří sem i zapamatování zavřených sdělení a pop-upů.',
  'consent.analyticsLabel': 'Analytika',
  'consent.analyticsDesc': 'Anonymní měření návštěvnosti, nákupního chování a interakce se sděleními (pop-upy, bannery).',
  'consent.marketingLabel': 'Marketing',
  'consent.marketingDesc': 'Personalizace nabídek a doporučení podle toho, co tě zajímá.',
  'footer.cookieSettings': 'Nastavení cookies',
  'glossary.title': 'Slovník pojmů',
  'glossary.intro':
    'Vysvětlujeme pojmy z chovatelství a krmiv — od „grain free" po taurin. U každého hesla najdete i produkty, kterých se týká.',
  'glossary.metaDescription':
    'Slovník chovatelských pojmů: krmiva, zdraví a péče o psy, kočky a další mazlíčky srozumitelně vysvětlené.',
  'glossary.searchLabel': 'Hledat pojem',
  'glossary.searchPlaceholder': 'Např. taurin, grain free…',
  'glossary.empty': 'Slovník se zatím plní. Zkuste to za chvíli.',
  'glossary.noResults': 'Žádné heslo neodpovídá hledání.',
  'glossary.back': 'Zpět do slovníku',
  'glossary.aliases': 'Také známé jako',
  'glossary.relatedProducts': 'Kde to koupíte',
  'glossary.relatedCategories': 'Související kategorie',
  'glossary.notFound': 'Pojem nenalezen',
  'glossary.notFoundMsg': 'Takový pojem ve slovníku není.',
  'glossary.loading': 'Načítám…',
  'glossary.priceFrom': 'od {price}',
  'glossary.footerLink': 'Slovník pojmů',
  'notFound.title': 'Stránka nenalezena',
  'notFound.text': 'Tahle adresa v obchodě není. Možná se překlepla, nebo zboží už nenabízíme.',
  'notFound.checking': 'Hledám, kam se stránka přestěhovala…',
  'files.heading': 'Ke stažení',
  'files.download': 'Stáhnout {name}',
  // Min/max objednatelné množství (#23). {min}/{max} jsou kusy, {what} je
  // „název – varianta". Košíkové hlášky (qty.cart*) říkají i CO s tím udělat.
  'qty.minInfo': 'Objednává se nejméně po {min} ks.',
  'qty.rangeInfo': 'Objednává se po {min}–{max} ks.',
  'qty.maxInfo': 'Nejvýš {max} ks na objednávku.',
  'qty.belowStock': 'Objednává se nejméně po {min} ks a tolik jich teď skladem není.',
  'qty.cartMin': '{what} se objednává nejméně po {min} ks. Zvyš prosím množství.',
  'qty.cartMax': '{what} lze objednat nejvýš {max} ks na objednávku. Sniž prosím množství.',
  // --------------------------------------------- vernostni body (#40)
  'co.points': 'Věrnostní body',
  'co.pointsUse': 'Uplatnit věrnostní body',
  'co.pointsBalance': 'Zůstatek {points} b. ({amount})',
  'co.pointsCount': 'Kolik bodů uplatnit',
  'co.pointsMax': 'Na tenhle nákup lze uplatnit nejvýš {points} b. ({amount}).',
  'co.pointsAll': 'Uplatnit vše',
  'co.pointsNone': 'Zatím nemáš žádné věrnostní body. Za každý nákup ti přibudou.',
  'co.pointsNoFit':
    'Na tenhle košík věrnostní body uplatnit nejde — kupón nebo akce vyčerpaly celou hodnotu zboží.',
  'co.pointsGuest': 'Věrnostní body může uplatnit jen přihlášený zákazník.',
  'co.pointsGuestLink': 'Přihlásit se',
  'co.pointsRefundNote':
    'Uplatněné body jsou způsobem platby této objednávky. Při částečné vratce se nevracejí.',
  'co.errPoints': 'Věrnostní body se nepodařilo ověřit.',
  'co.errPointsChanged':
    'Z věrnostních bodů by se strhlo víc, než ukazoval souhrn — mezitím se změnila cena. Souhrn jsme aktualizovali, zkontroluj ho prosím a objednávku odešli znovu.',
  'co.errPointsBalance':
    'Na věrnostním účtu už tolik bodů není. Zůstatek jsme načetli znovu — zkontroluj prosím souhrn a objednávku odešli znovu.',
  'co.errPointsGuest':
    'Přihlášení vypršelo, takže věrnostní body uplatnit nejde. Přihlas se prosím a objednávku odešli znovu.',
  /*
   * Cena za měrnou jednotku (#9). Zkratka jednotky se nepřekládá — `kg` i `l`
   * jsou soustava SI a ve všech čtyřech jazycích se píšou stejně. Přeložený
   * je popisek, který se ukáže po najetí myší.
   */
  'unit.perKg': '{price}/kg',
  'unit.perL': '{price}/l',
  'unit.titleKg': 'Cena za kilogram',
  'unit.titleL': 'Cena za litr',
  /* Sociální sítě a sdílení (#31). Názvy sítí jsou značky, nepřekládají se. */
  'social.heading': 'Sledujte nás',
  'social.follow': 'Sledujte nás na {network}',
  'share.heading': 'Sdílet',
  'share.facebook': 'Facebook',
  'share.x': 'X',
  'share.email': 'E-mailem',
  'share.copy': 'Kopírovat odkaz',
  'share.copied': 'Zkopírováno',
  'share.copyManual': 'Zkopírujte odkaz ručně:',
};

const sk: Dict = {
  'bar.sameDay': 'Odosielame v ten istý deň',
  'bar.freeShip': 'Doprava zdarma od {amount}',
  'bar.returns': 'Vrátenie do 30 dní',
  'nav.myOrder': 'Moja objednávka',
  'nav.account': 'Účet a košík',
  'cart.title': 'Košík',
  'cart.goodsTotal': 'Tovar spolu',
  'cart.toCart': 'Do košíka',
  'cart.checkout': 'K pokladni',
  'cart.shippingNote': 'Doprava sa doráta v pokladni.',
  'cart.empty': 'Obsah košíka',
  'freeship.remaining': 'Do dopravy zdarma zostáva',
  'freeship.reached': 'Máš dopravu zdarma 🎉',
  'footer.tagline': 'Chovateľské potreby pre tých, čo doma nie sú sami.',
  'poll.title': 'Anketa',
  'poll.vote': 'Hlasovať',
  'poll.thanks': 'Ďakujeme za váš hlas.',
  'poll.totalVotes': 'Spolu hlasov: {count}',
  'skip.toContent': 'Preskočiť na obsah',
  'lang.switch': 'Jazyk',
  'cart.emptyMsg': 'Košík je prázdny.',
  'cart.backToShop': 'Späť do obchodu',
  'cart.priceChanged': 'Ceny sa od vloženia do košíka zmenili. Platí suma uvedená nižšie.',
  'cart.colGoods': 'Tovar',
  'cart.colQty': 'Počet',
  'cart.colTotal': 'Spolu',
  'cart.remove': 'Odobrať',
  'cart.settlement': 'Ceny sú orientačne prepočítané kurzom ČNB. Účtujeme v korunách: {amount}.',
  'cart.freeShip': 'Doprava zdarma.',
  'cart.shipFrom': 'Doprava od {price} — konkrétne možnosti vyberieš v ďalšom kroku.',
  'cart.continueShopping': 'Pokračovať v nákupe',
  'co.title': 'Pokladňa',
  'co.submitError': 'Objednávku sa nepodarilo odoslať.',
  'co.contact': 'Kontakt',
  'co.email': 'E-mail',
  'co.phone': 'Telefón',
  'co.shippingAddress': 'Doručovacia adresa',
  'co.fullName': 'Meno a priezvisko',
  'co.street': 'Ulica a číslo domu',
  'co.city': 'Mesto',
  'co.zip': 'PSČ',
  'co.country': 'Krajina doručenia',
  'co.countryCZ': 'Česko',
  'co.countrySK': 'Slovensko',
  'co.countryDE': 'Nemecko',
  'co.countryPL': 'Poľsko',
  'co.countryAT': 'Rakúsko',
  'co.ossNote': 'Objednávka do zahraničia: účtuje sa DPH cieľovej krajiny (režim OSS). Cena vr. DPH zostáva rovnaká, mení sa len rozpad dane.',
  'co.shipping': 'Doprava',
  'co.loading': 'Načítavam…',
  'co.freeOver': 'Zdarma pri nákupe nad {amount}',
  'co.free': 'zdarma',
  'co.pickPoint': 'Vyber výdajné miesto',
  'co.payment': 'Platba',
  'co.note': 'Poznámka',
  'co.noteHint': 'Čokoľvek, čo by sme mali vedieť (nepovinné)',
  'co.summary': 'Súhrn',
  'co.goods': 'Tovar',
  'co.discount': 'Zľava {code}',
  'co.total': 'Spolu',
  'co.settlement': 'Ceny sú orientačne prepočítané kurzom ČNB. Platba prebieha v korunách — účtujeme {amount}.',
  'co.couponLabel': 'Zľavový kód',
  'co.couponApply': 'Použiť',
  'co.couponApplied': 'Kód {code} uplatnený.',
  'co.voucher': 'Darčekový poukaz',
  'co.voucherApply': 'Použiť',
  'co.voucherApplied': 'Poukaz {code} uplatnený.',
  'co.errVoucher': 'Poukaz sa nepodarilo overiť.',
  'co.errVoucherChanged':
    'Z darčekového poukazu by sa strhlo viac, než ukazoval súhrn (napríklad skončila akcia). Skontroluj prosím súhrn a objednávku odošli znova.',
  'co.terms': 'Súhlasím s obchodnými podmienkami a spracovaním osobných údajov.',
  'co.submitting': 'Odosielam…',
  'co.submit': 'Záväzne objednať',
  'co.errShipping': 'Nepodarilo sa načítať dopravu.',
  'co.errCoupon': 'Kód sa nepodarilo overiť.',
  'co.promoDiscount': 'Akcia',
  'promo.title': 'Uplatnené akcie',
  'promo.saved': 'Ušetríte {amount}',
  'promo.gift': 'Darček',
  'promo.giftFree': 'zdarma',
  'promo.freeUnits': 'Zdarma',
  'promo.setPrice': 'Zvýhodnená sada',
  'promo.almost': 'Do akcie zostáva {amount}',
  'consent.title': 'Cookies a súkromie',
  'consent.text': 'Nevyhnutné cookies držia košík a prihlásenie. So súhlasom navyše anonymne meriame, ako sa obchod používa, aby sme ho vedeli zlepšovať.',
  'consent.acceptAll': 'Prijať všetko',
  'consent.essentialOnly': 'Len nevyhnutné',
  'consent.settings': 'Nastavenia',
  'consent.save': 'Uložiť voľbu',
  'consent.close': 'Zavrieť',
  'consent.essentialLabel': 'Nevyhnutné',
  'consent.essentialDesc': 'Košík, prihlásenie, jazyk a mena. Bez nich obchod nefunguje – nedajú sa vypnúť. Patrí sem aj zapamätanie zatvorených oznamov a pop-upov.',
  'consent.analyticsLabel': 'Analytika',
  'consent.analyticsDesc': 'Anonymné meranie návštevnosti, nákupného správania a interakcie s oznamami (pop-upy, bannery).',
  'consent.marketingLabel': 'Marketing',
  'consent.marketingDesc': 'Personalizácia ponúk a odporúčaní podľa toho, čo ťa zaujíma.',
  'footer.cookieSettings': 'Nastavenia cookies',
  'glossary.title': 'Slovník pojmov',
  'glossary.intro':
    'Vysvetľujeme pojmy z chovateľstva a krmív — od „grain free" po taurín. Pri každom hesle nájdete aj produkty, ktorých sa týka.',
  'glossary.metaDescription':
    'Slovník chovateľských pojmov: krmivá, zdravie a starostlivosť o psy, mačky a ďalších miláčikov zrozumiteľne vysvetlené.',
  'glossary.searchLabel': 'Hľadať pojem',
  'glossary.searchPlaceholder': 'Napr. taurín, grain free…',
  'glossary.empty': 'Slovník sa zatiaľ napĺňa. Skúste to o chvíľu.',
  'glossary.noResults': 'Žiadne heslo nezodpovedá hľadaniu.',
  'glossary.back': 'Späť do slovníka',
  'glossary.aliases': 'Známe aj ako',
  'glossary.relatedProducts': 'Kde to kúpite',
  'glossary.relatedCategories': 'Súvisiace kategórie',
  'glossary.notFound': 'Pojem nenájdený',
  'glossary.notFoundMsg': 'Taký pojem v slovníku nie je.',
  'glossary.loading': 'Načítavam…',
  'glossary.priceFrom': 'od {price}',
  'glossary.footerLink': 'Slovník pojmov',
  'notFound.title': 'Stránka sa nenašla',
  'notFound.text': 'Táto adresa v obchode nie je. Možno je v nej preklep, alebo tovar už neponúkame.',
  'notFound.checking': 'Hľadám, kam sa stránka presťahovala…',
  'files.heading': 'Na stiahnutie',
  'files.download': 'Stiahnuť {name}',
  'qty.minInfo': 'Objednáva sa najmenej po {min} ks.',
  'qty.rangeInfo': 'Objednáva sa po {min}–{max} ks.',
  'qty.maxInfo': 'Najviac {max} ks na objednávku.',
  'qty.belowStock': 'Objednáva sa najmenej po {min} ks a toľko ich teraz skladom nie je.',
  'qty.cartMin': '{what} sa objednáva najmenej po {min} ks. Zvýš prosím množstvo.',
  'qty.cartMax': '{what} možno objednať najviac {max} ks na objednávku. Zníž prosím množstvo.',
  // --------------------------------------------- vernostni body (#40)
  'co.points': 'Vernostné body',
  'co.pointsUse': 'Uplatniť vernostné body',
  'co.pointsBalance': 'Zostatok {points} b. ({amount})',
  'co.pointsCount': 'Koľko bodov uplatniť',
  'co.pointsMax': 'Na tento nákup možno uplatniť najviac {points} b. ({amount}).',
  'co.pointsAll': 'Uplatniť všetko',
  'co.pointsNone': 'Zatiaľ nemáš žiadne vernostné body. Za každý nákup ti pribudnú.',
  'co.pointsNoFit':
    'Na tento košík vernostné body uplatniť nejde — kupón alebo akcie vyčerpali celú hodnotu tovaru.',
  'co.pointsGuest': 'Vernostné body môže uplatniť len prihlásený zákazník.',
  'co.pointsGuestLink': 'Prihlásiť sa',
  'co.pointsRefundNote':
    'Uplatnené body sú spôsobom platby tejto objednávky. Pri čiastočnej vratke sa nevracajú.',
  'co.errPoints': 'Vernostné body sa nepodarilo overiť.',
  'co.errPointsChanged':
    'Z vernostných bodov by sa strhlo viac, než ukazoval súhrn — medzitým sa zmenila cena. Súhrn sme aktualizovali, skontroluj ho prosím a objednávku odošli znova.',
  'co.errPointsBalance':
    'Na vernostnom účte už toľko bodov nie je. Zostatok sme načítali znova — skontroluj prosím súhrn a objednávku odošli znova.',
  'co.errPointsGuest':
    'Prihlásenie vypršalo, takže vernostné body uplatniť nejde. Prihlás sa prosím a objednávku odošli znova.',
  'unit.perKg': '{price}/kg',
  'unit.perL': '{price}/l',
  'unit.titleKg': 'Cena za kilogram',
  'unit.titleL': 'Cena za liter',
  'social.heading': 'Sledujte nás',
  'social.follow': 'Sledujte nás na {network}',
  'share.heading': 'Zdieľať',
  'share.facebook': 'Facebook',
  'share.x': 'X',
  'share.email': 'E-mailom',
  'share.copy': 'Kopírovať odkaz',
  'share.copied': 'Skopírované',
  'share.copyManual': 'Skopírujte odkaz ručne:',
};

const de: Dict = {
  'bar.sameDay': 'Versand am selben Tag',
  'bar.freeShip': 'Kostenloser Versand ab {amount}',
  'bar.returns': 'Rückgabe innerhalb von 30 Tagen',
  'nav.myOrder': 'Meine Bestellung',
  'nav.account': 'Konto und Warenkorb',
  'cart.title': 'Warenkorb',
  'cart.goodsTotal': 'Warenwert gesamt',
  'cart.toCart': 'In den Warenkorb',
  'cart.checkout': 'Zur Kasse',
  'cart.shippingNote': 'Der Versand wird an der Kasse berechnet.',
  'cart.empty': 'Warenkorbinhalt',
  'freeship.remaining': 'Bis zum kostenlosen Versand fehlen',
  'freeship.reached': 'Du hast kostenlosen Versand 🎉',
  'footer.tagline': 'Tierbedarf für alle, die zu Hause nicht allein sind.',
  'poll.title': 'Umfrage',
  'poll.vote': 'Abstimmen',
  'poll.thanks': 'Danke für Ihre Stimme.',
  'poll.totalVotes': 'Stimmen gesamt: {count}',
  'skip.toContent': 'Zum Inhalt springen',
  'lang.switch': 'Sprache',
  'cart.emptyMsg': 'Der Warenkorb ist leer.',
  'cart.backToShop': 'Zurück zum Shop',
  'cart.priceChanged': 'Die Preise haben sich seit dem Hinzufügen geändert. Es gilt der unten angegebene Betrag.',
  'cart.colGoods': 'Artikel',
  'cart.colQty': 'Menge',
  'cart.colTotal': 'Gesamt',
  'cart.remove': 'Entfernen',
  'cart.settlement': 'Die Preise sind unverbindlich zum ČNB-Kurs umgerechnet. Abgerechnet wird in Kronen: {amount}.',
  'cart.freeShip': 'Kostenloser Versand.',
  'cart.shipFrom': 'Versand ab {price} — die genauen Optionen wählst du im nächsten Schritt.',
  'cart.continueShopping': 'Weiter einkaufen',
  'co.title': 'Kasse',
  'co.submitError': 'Die Bestellung konnte nicht abgesendet werden.',
  'co.contact': 'Kontakt',
  'co.email': 'E-Mail',
  'co.phone': 'Telefon',
  'co.shippingAddress': 'Lieferadresse',
  'co.fullName': 'Vor- und Nachname',
  'co.street': 'Straße und Hausnummer',
  'co.city': 'Stadt',
  'co.zip': 'PLZ',
  'co.country': 'Lieferland',
  'co.countryCZ': 'Tschechien',
  'co.countrySK': 'Slowakei',
  'co.countryDE': 'Deutschland',
  'co.countryPL': 'Polen',
  'co.countryAT': 'Österreich',
  'co.ossNote': 'Bestellung ins Ausland: Es gilt die Mehrwertsteuer des Ziellandes (OSS-Verfahren). Der Bruttopreis bleibt gleich, nur die Steueraufteilung ändert sich.',
  'co.shipping': 'Versand',
  'co.loading': 'Lädt…',
  'co.freeOver': 'Kostenlos ab einem Einkauf über {amount}',
  'co.free': 'kostenlos',
  'co.pickPoint': 'Abholstelle wählen',
  'co.payment': 'Zahlung',
  'co.note': 'Anmerkung',
  'co.noteHint': 'Alles, was wir wissen sollten (optional)',
  'co.summary': 'Zusammenfassung',
  'co.goods': 'Artikel',
  'co.discount': 'Rabatt {code}',
  'co.total': 'Gesamt',
  'co.settlement': 'Die Preise sind unverbindlich zum ČNB-Kurs umgerechnet. Die Zahlung erfolgt in Kronen — abgerechnet werden {amount}.',
  'co.couponLabel': 'Gutscheincode',
  'co.couponApply': 'Einlösen',
  'co.couponApplied': 'Code {code} eingelöst.',
  'co.voucher': 'Geschenkgutschein',
  'co.voucherApply': 'Einlösen',
  'co.voucherApplied': 'Gutschein {code} eingelöst.',
  'co.errVoucher': 'Der Gutschein konnte nicht überprüft werden.',
  'co.errVoucherChanged':
    'Vom Geschenkgutschein würde mehr abgebucht, als die Übersicht angezeigt hat (zum Beispiel ist eine Aktion ausgelaufen). Bitte prüfe die Übersicht und sende die Bestellung erneut ab.',
  'co.terms': 'Ich stimme den AGB und der Verarbeitung personenbezogener Daten zu.',
  'co.submitting': 'Wird gesendet…',
  'co.submit': 'Zahlungspflichtig bestellen',
  'co.errShipping': 'Die Versandarten konnten nicht geladen werden.',
  'co.errCoupon': 'Der Code konnte nicht überprüft werden.',
  'co.promoDiscount': 'Aktion',
  'promo.title': 'Angewandte Aktionen',
  'promo.saved': 'Du sparst {amount}',
  'promo.gift': 'Geschenk',
  'promo.giftFree': 'gratis',
  'promo.freeUnits': 'Gratis',
  'promo.setPrice': 'Vorteilsset',
  'promo.almost': 'Bis zur Aktion fehlen {amount}',
  'consent.title': 'Cookies und Datenschutz',
  'consent.text': 'Notwendige Cookies halten Warenkorb und Anmeldung. Mit deiner Zustimmung messen wir zusätzlich anonym, wie der Shop genutzt wird, um ihn zu verbessern.',
  'consent.acceptAll': 'Alle akzeptieren',
  'consent.essentialOnly': 'Nur notwendige',
  'consent.settings': 'Einstellungen',
  'consent.save': 'Auswahl speichern',
  'consent.close': 'Schließen',
  'consent.essentialLabel': 'Notwendig',
  'consent.essentialDesc': 'Warenkorb, Anmeldung, Sprache und Währung. Ohne sie funktioniert der Shop nicht – sie lassen sich nicht abschalten. Dazu gehört auch das Merken geschlossener Hinweise und Pop-ups.',
  'consent.analyticsLabel': 'Analyse',
  'consent.analyticsDesc': 'Anonyme Messung von Besucherzahlen, Kaufverhalten und Interaktion mit Hinweisen (Pop-ups, Banner).',
  'consent.marketingLabel': 'Marketing',
  'consent.marketingDesc': 'Personalisierte Angebote und Empfehlungen nach deinen Interessen.',
  'footer.cookieSettings': 'Cookie-Einstellungen',
  'glossary.title': 'Glossar',
  'glossary.intro':
    'Wir erklären Begriffe rund um Tierhaltung und Futter — von „grain free" bis Taurin. Zu jedem Eintrag finden Sie auch passende Produkte.',
  'glossary.metaDescription':
    'Glossar für Tierhalter: Futter, Gesundheit und Pflege von Hunden, Katzen und anderen Haustieren verständlich erklärt.',
  'glossary.searchLabel': 'Begriff suchen',
  'glossary.searchPlaceholder': 'z. B. Taurin, grain free…',
  'glossary.empty': 'Das Glossar wird noch gefüllt. Bitte später wieder vorbeischauen.',
  'glossary.noResults': 'Kein Eintrag passt zur Suche.',
  'glossary.back': 'Zurück zum Glossar',
  'glossary.aliases': 'Auch bekannt als',
  'glossary.relatedProducts': 'Wo Sie es kaufen',
  'glossary.relatedCategories': 'Passende Kategorien',
  'glossary.notFound': 'Begriff nicht gefunden',
  'glossary.notFoundMsg': 'Diesen Begriff gibt es im Glossar nicht.',
  'glossary.loading': 'Wird geladen…',
  'glossary.priceFrom': 'ab {price}',
  'glossary.footerLink': 'Glossar',
  'notFound.title': 'Seite nicht gefunden',
  'notFound.text': 'Diese Adresse gibt es im Shop nicht. Vielleicht ein Tippfehler, oder die Ware ist nicht mehr im Angebot.',
  'notFound.checking': 'Wir suchen, wohin die Seite umgezogen ist…',
  'files.heading': 'Zum Herunterladen',
  'files.download': '{name} herunterladen',
  'qty.minInfo': 'Mindestbestellmenge: {min} Stück.',
  'qty.rangeInfo': 'Bestellbar in Mengen von {min}–{max} Stück.',
  'qty.maxInfo': 'Höchstens {max} Stück pro Bestellung.',
  'qty.belowStock': 'Mindestbestellmenge {min} Stück — so viele sind derzeit nicht auf Lager.',
  'qty.cartMin': '{what}: Mindestbestellmenge {min} Stück. Bitte erhöhe die Menge.',
  'qty.cartMax': '{what}: höchstens {max} Stück pro Bestellung. Bitte reduziere die Menge.',
  // --------------------------------------------- vernostni body (#40)
  'co.points': 'Treuepunkte',
  'co.pointsUse': 'Treuepunkte einlösen',
  'co.pointsBalance': 'Guthaben {points} P. ({amount})',
  'co.pointsCount': 'Wie viele Punkte einlösen',
  'co.pointsMax': 'Für diesen Einkauf sind höchstens {points} P. einlösbar ({amount}).',
  'co.pointsAll': 'Alles einlösen',
  'co.pointsNone': 'Du hast noch keine Treuepunkte. Mit jedem Einkauf kommen welche dazu.',
  'co.pointsNoFit':
    'Für diesen Warenkorb lassen sich keine Treuepunkte einlösen — Gutschein oder Aktionen haben den Warenwert bereits aufgebraucht.',
  'co.pointsGuest': 'Treuepunkte können nur angemeldete Kundinnen und Kunden einlösen.',
  'co.pointsGuestLink': 'Anmelden',
  'co.pointsRefundNote':
    'Eingelöste Punkte sind eine Zahlungsart dieser Bestellung. Bei einer Teilerstattung werden sie nicht zurückgebucht.',
  'co.errPoints': 'Die Treuepunkte konnten nicht geprüft werden.',
  'co.errPointsChanged':
    'Es würden mehr Treuepunkte abgezogen, als die Übersicht gezeigt hat — der Preis hat sich zwischenzeitlich geändert. Wir haben die Übersicht aktualisiert; bitte prüfe sie und sende die Bestellung erneut ab.',
  'co.errPointsBalance':
    'So viele Punkte sind auf dem Treuekonto nicht mehr. Wir haben das Guthaben neu geladen — bitte prüfe die Übersicht und sende die Bestellung erneut ab.',
  'co.errPointsGuest':
    'Die Anmeldung ist abgelaufen, deshalb lassen sich keine Treuepunkte einlösen. Bitte melde dich an und sende die Bestellung erneut ab.',
  'unit.perKg': '{price}/kg',
  'unit.perL': '{price}/l',
  'unit.titleKg': 'Preis pro Kilogramm',
  'unit.titleL': 'Preis pro Liter',
  'social.heading': 'Folgen Sie uns',
  'social.follow': 'Folgen Sie uns auf {network}',
  'share.heading': 'Teilen',
  'share.facebook': 'Facebook',
  'share.x': 'X',
  'share.email': 'Per E-Mail',
  'share.copy': 'Link kopieren',
  'share.copied': 'Kopiert',
  'share.copyManual': 'Link bitte manuell kopieren:',
};

const pl: Dict = {
  'bar.sameDay': 'Wysyłka tego samego dnia',
  'bar.freeShip': 'Darmowa dostawa od {amount}',
  'bar.returns': 'Zwrot do 30 dni',
  'nav.myOrder': 'Moje zamówienie',
  'nav.account': 'Konto i koszyk',
  'cart.title': 'Koszyk',
  'cart.goodsTotal': 'Wartość towarów',
  'cart.toCart': 'Do koszyka',
  'cart.checkout': 'Do kasy',
  'cart.shippingNote': 'Dostawa zostanie doliczona przy kasie.',
  'cart.empty': 'Zawartość koszyka',
  'freeship.remaining': 'Do darmowej dostawy brakuje',
  'freeship.reached': 'Masz darmową dostawę 🎉',
  'footer.tagline': 'Artykuły dla zwierząt — dla tych, którzy w domu nie są sami.',
  'poll.title': 'Ankieta',
  'poll.vote': 'Głosuj',
  'poll.thanks': 'Dziękujemy za Twój głos.',
  'poll.totalVotes': 'Łącznie głosów: {count}',
  'skip.toContent': 'Przejdź do treści',
  'lang.switch': 'Język',
  'cart.emptyMsg': 'Koszyk jest pusty.',
  'cart.backToShop': 'Wróć do sklepu',
  'cart.priceChanged': 'Ceny zmieniły się od dodania do koszyka. Obowiązuje kwota podana poniżej.',
  'cart.colGoods': 'Towar',
  'cart.colQty': 'Ilość',
  'cart.colTotal': 'Razem',
  'cart.remove': 'Usuń',
  'cart.settlement': 'Ceny są orientacyjnie przeliczone kursem ČNB. Rozliczamy w koronach: {amount}.',
  'cart.freeShip': 'Darmowa dostawa.',
  'cart.shipFrom': 'Dostawa od {price} — konkretne opcje wybierzesz w następnym kroku.',
  'cart.continueShopping': 'Kontynuuj zakupy',
  'co.title': 'Kasa',
  'co.submitError': 'Nie udało się wysłać zamówienia.',
  'co.contact': 'Kontakt',
  'co.email': 'E-mail',
  'co.phone': 'Telefon',
  'co.shippingAddress': 'Adres dostawy',
  'co.fullName': 'Imię i nazwisko',
  'co.street': 'Ulica i numer domu',
  'co.city': 'Miasto',
  'co.zip': 'Kod pocztowy',
  'co.country': 'Kraj dostawy',
  'co.countryCZ': 'Czechy',
  'co.countrySK': 'Słowacja',
  'co.countryDE': 'Niemcy',
  'co.countryPL': 'Polska',
  'co.countryAT': 'Austria',
  'co.ossNote': 'Zamówienie za granicę: naliczany jest VAT kraju docelowego (procedura OSS). Cena brutto pozostaje taka sama, zmienia się tylko rozbicie podatku.',
  'co.shipping': 'Dostawa',
  'co.loading': 'Ładuję…',
  'co.freeOver': 'Za darmo przy zakupie powyżej {amount}',
  'co.free': 'za darmo',
  'co.pickPoint': 'Wybierz punkt odbioru',
  'co.payment': 'Płatność',
  'co.note': 'Uwagi',
  'co.noteHint': 'Cokolwiek, co powinniśmy wiedzieć (opcjonalnie)',
  'co.summary': 'Podsumowanie',
  'co.goods': 'Towar',
  'co.discount': 'Rabat {code}',
  'co.total': 'Razem',
  'co.settlement': 'Ceny są orientacyjnie przeliczone kursem ČNB. Płatność odbywa się w koronach — rozliczamy {amount}.',
  'co.couponLabel': 'Kod rabatowy',
  'co.couponApply': 'Zastosuj',
  'co.couponApplied': 'Kod {code} zastosowany.',
  'co.voucher': 'Bon podarunkowy',
  'co.voucherApply': 'Zastosuj',
  'co.voucherApplied': 'Bon {code} zastosowany.',
  'co.errVoucher': 'Nie udało się zweryfikować bonu.',
  'co.errVoucherChanged':
    'Z bonu podarunkowego zostałaby pobrana wyższa kwota, niż pokazywało podsumowanie (na przykład skończyła się promocja). Sprawdź proszę podsumowanie i wyślij zamówienie ponownie.',
  'co.terms': 'Akceptuję regulamin i przetwarzanie danych osobowych.',
  'co.submitting': 'Wysyłam…',
  'co.submit': 'Zamawiam z obowiązkiem zapłaty',
  'co.errShipping': 'Nie udało się wczytać opcji dostawy.',
  'co.errCoupon': 'Nie udało się zweryfikować kodu.',
  'co.promoDiscount': 'Promocja',
  'promo.title': 'Zastosowane promocje',
  'promo.saved': 'Oszczędzasz {amount}',
  'promo.gift': 'Prezent',
  'promo.giftFree': 'gratis',
  'promo.freeUnits': 'Gratis',
  'promo.setPrice': 'Zestaw promocyjny',
  'promo.almost': 'Do promocji brakuje {amount}',
  'consent.title': 'Cookies i prywatność',
  'consent.text': 'Niezbędne cookies utrzymują koszyk i logowanie. Za zgodą dodatkowo anonimowo mierzymy, jak sklep jest używany, aby go ulepszać.',
  'consent.acceptAll': 'Zaakceptuj wszystkie',
  'consent.essentialOnly': 'Tylko niezbędne',
  'consent.settings': 'Ustawienia',
  'consent.save': 'Zapisz wybór',
  'consent.close': 'Zamknij',
  'consent.essentialLabel': 'Niezbędne',
  'consent.essentialDesc': 'Koszyk, logowanie, język i waluta. Bez nich sklep nie działa – nie da się ich wyłączyć. Obejmuje to też zapamiętanie zamkniętych komunikatów i pop-upów.',
  'consent.analyticsLabel': 'Analityka',
  'consent.analyticsDesc': 'Anonimowy pomiar ruchu, zachowań zakupowych i interakcji z komunikatami (pop-upy, bannery).',
  'consent.marketingLabel': 'Marketing',
  'consent.marketingDesc': 'Personalizacja ofert i rekomendacji według Twoich zainteresowań.',
  'footer.cookieSettings': 'Ustawienia cookies',
  'glossary.title': 'Słownik pojęć',
  'glossary.intro':
    'Wyjaśniamy pojęcia z hodowli i karmienia — od „grain free" po taurynę. Przy każdym haśle znajdziesz też powiązane produkty.',
  'glossary.metaDescription':
    'Słownik pojęć dla właścicieli zwierząt: karma, zdrowie i pielęgnacja psów, kotów i innych pupili zrozumiale wyjaśnione.',
  'glossary.searchLabel': 'Szukaj pojęcia',
  'glossary.searchPlaceholder': 'Np. tauryna, grain free…',
  'glossary.empty': 'Słownik dopiero się zapełnia. Zajrzyj za chwilę.',
  'glossary.noResults': 'Żadne hasło nie pasuje do wyszukiwania.',
  'glossary.back': 'Powrót do słownika',
  'glossary.aliases': 'Znane też jako',
  'glossary.relatedProducts': 'Gdzie to kupić',
  'glossary.relatedCategories': 'Powiązane kategorie',
  'glossary.notFound': 'Nie znaleziono pojęcia',
  'glossary.notFoundMsg': 'Takiego pojęcia nie ma w słowniku.',
  'glossary.loading': 'Ładuję…',
  'glossary.priceFrom': 'od {price}',
  'glossary.footerLink': 'Słownik pojęć',
  'notFound.title': 'Nie znaleziono strony',
  'notFound.text': 'Tego adresu w sklepie nie ma. Może to literówka, albo tego towaru już nie oferujemy.',
  'notFound.checking': 'Szukamy, dokąd strona się przeniosła…',
  'files.heading': 'Do pobrania',
  'files.download': 'Pobierz {name}',
  'qty.minInfo': 'Zamówienie minimum {min} szt.',
  'qty.rangeInfo': 'Zamówienie od {min} do {max} szt.',
  'qty.maxInfo': 'Najwyżej {max} szt. na zamówienie.',
  'qty.belowStock': 'Zamówienie minimum {min} szt., a tyle nie ma teraz na stanie.',
  'qty.cartMin': '{what}: zamówienie minimum {min} szt. Zwiększ proszę ilość.',
  'qty.cartMax': '{what}: najwyżej {max} szt. na zamówienie. Zmniejsz proszę ilość.',
  // --------------------------------------------- vernostni body (#40)
  'co.points': 'Punkty lojalnościowe',
  'co.pointsUse': 'Wykorzystaj punkty lojalnościowe',
  'co.pointsBalance': 'Saldo {points} pkt ({amount})',
  'co.pointsCount': 'Ile punktów wykorzystać',
  'co.pointsMax': 'Na ten zakup można wykorzystać najwyżej {points} pkt ({amount}).',
  'co.pointsAll': 'Wykorzystaj wszystko',
  'co.pointsNone': 'Nie masz jeszcze punktów lojalnościowych. Przybędą przy każdym zakupie.',
  'co.pointsNoFit':
    'Do tego koszyka nie da się wykorzystać punktów lojalnościowych — kupon lub promocje wyczerpały całą wartość towaru.',
  'co.pointsGuest': 'Punkty lojalnościowe może wykorzystać tylko zalogowany klient.',
  'co.pointsGuestLink': 'Zaloguj się',
  'co.pointsRefundNote':
    'Wykorzystane punkty są formą płatności za to zamówienie. Przy częściowym zwrocie nie wracają.',
  'co.errPoints': 'Nie udało się zweryfikować punktów lojalnościowych.',
  'co.errPointsChanged':
    'Z punktów lojalnościowych pobrano by więcej, niż pokazywało podsumowanie — w międzyczasie zmieniła się cena. Zaktualizowaliśmy podsumowanie; sprawdź je i wyślij zamówienie ponownie.',
  'co.errPointsBalance':
    'Na koncie lojalnościowym nie ma już tylu punktów. Wczytaliśmy saldo na nowo — sprawdź podsumowanie i wyślij zamówienie ponownie.',
  'co.errPointsGuest':
    'Sesja wygasła, więc nie można wykorzystać punktów lojalnościowych. Zaloguj się i wyślij zamówienie ponownie.',
  'unit.perKg': '{price}/kg',
  'unit.perL': '{price}/l',
  'unit.titleKg': 'Cena za kilogram',
  'unit.titleL': 'Cena za litr',
  'social.heading': 'Obserwuj nas',
  'social.follow': 'Obserwuj nas na {network}',
  'share.heading': 'Udostępnij',
  'share.facebook': 'Facebook',
  'share.x': 'X',
  'share.email': 'E-mailem',
  'share.copy': 'Kopiuj link',
  'share.copied': 'Skopiowano',
  'share.copyManual': 'Skopiuj link ręcznie:',
};

export const MESSAGES: Record<Lang, Dict> = { cs, sk, de, pl };
